module.exports = __webpack_public_path__ + "static/media/facebook.81c9e7cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 1092
// module chunks = 0